import { ZodType } from 'zod';

export function optionalInput<TSchema extends ZodType>(schema: TSchema) {
  return schema.nullable();
}
